export default "__VITE_ASSET__Bg65fh10__"